export const ScannerLogContextType = {
	other: 0,
	order: 1,
	inventorization: 2,
};
